var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-404-container" },
    [_c("fifty-fifty", { attrs: { schema: _vm.schema } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }